<template>
  <div class="timestamp-container">
    <div class="background-line"></div>
    <FriedH5 class="timestamp"> {{ date }} </FriedH5>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    date: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.timestamp-container {
  position: relative;

  .background-line {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--blue-95);
  }

  .timestamp {
    position: relative;
    z-index: 1;
    text-align: center;
    color: var(--link-blue);
    background-color: var(--white);
    width: fit-content;
    margin: var(--spacing-50) auto;
    padding: 0 var(--spacing-100);
  }
}
</style>
